<template>
  <v-app>
    <!-- Barra de navegación superior -->
    <v-app-bar app color="black" elevate-on-scroll height="90" class="main-navbar">
      <v-container class="px-0">
        <v-row align="center" justify="space-between">
          <!-- Logo y nombre -->
          <v-col cols="auto" class="d-flex align-center">
            <v-img
              src="@/assets/logo2.png"
              max-height="100"
              max-width="210"
              contain
              class="mr-3"
              alt="LearnPlay Solutions Logo"
              @click="$router.push('/')"
              style="cursor: pointer"
            ></v-img>
          </v-col>

          <!-- Menú de navegación -->
          <v-col cols="auto" class="d-none d-md-flex" style="align-items: center;">
            <v-btn text to="/" class="nav-btn">Home</v-btn>
            <!-- Menú desplegable About -->
            <v-menu open-on-hover offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" class="nav-btn">Approach</v-btn>
              </template>
              <v-list class="nav-dropdown">
                <v-list-item
                  v-for="(item, index) in approachItems"
                  :key="index"
                  :to="item.to"
                  link
                  class="dropdown-item"
                  @click="approachMenu = false"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-menu open-on-hover offset-y transition="slide-y-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on" class="nav-btn">About</v-btn>
              </template>
              <v-list class="nav-dropdown">
                <v-list-item
                  v-for="(item, index) in aboutItems"
                  :key="index"
                  :to="item.to"
                  link
                  class="dropdown-item"
                  @click="aboutMenu = false"
                >
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            
            <v-btn text to="/store" class="nav-btn">Store</v-btn>
            <v-btn
              to="/contact"
              class="contact-btn"
              depressed
            >
              Contact Us
            </v-btn>
            <!-- Cart icon -->
            <v-btn
              icon
              class="nav-btn"
              title="Cart"
              @click="openCart"
            >
              <v-badge
                :content="cartCount"
                :value="cartCount > 0"
                color="#2E7D32"
                overlap
              >
                <v-icon>mdi-cart-outline</v-icon>
              </v-badge>
            </v-btn>
            <v-menu offset-y v-model="accountMenu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="nav-btn" title="Account" v-bind="attrs" v-on="on">
                  <v-icon>mdi-account</v-icon>
                </v-btn>
              </template>
              <v-list class="nav-dropdown">
                <v-list-item
                  v-if="isLoggedIn"
                  to="/orders"
                  link
                  class="dropdown-item"
                  @click="accountMenu = false"
                >
                  <v-list-item-title>My Orders</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="isLoggedIn"
                  to="/profile"
                  link
                  class="dropdown-item"
                  @click="accountMenu = false"
                >
                  <v-list-item-title>Profile</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="isLoggedIn"
                  class="dropdown-item"
                  @click="signOut"
                >
                  <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!isLoggedIn"
                  to="/login"
                  link
                  class="dropdown-item"
                  @click="accountMenu = false"
                >
                  <v-list-item-title>Sign In</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="!isLoggedIn"
                  to="/register"
                  link
                  class="dropdown-item"
                  @click="accountMenu = false"
                >
                  <v-list-item-title>Sign Up</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>

          <!-- Menú móvil -->
          <v-col cols="auto" class="d-flex d-md-none">
            <v-menu offset-y v-model="mobileMenu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="mobile-menu-btn">
                  <v-icon color="white">mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-list class="mobile-nav">
                <v-list-item to="/" @click="mobileMenu = false">
                  <v-list-item-title>Home</v-list-item-title>
                </v-list-item>
                <v-list-group :value="true" @click:activator="mobileMenu = false">
                  <template v-slot:activator>
                    <v-list-item-title>Approach</v-list-item-title>
                  </template>
                  <v-list-item
                    v-for="(item, index) in approachItems"
                    :key="index"
                    :to="item.to"
                    link
                    @click="mobileMenu = false"
                  >
                    <v-list-item-title>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <v-list-group :value="true" @click:activator="mobileMenu = false">
                  <template v-slot:activator>
                    <v-list-item-title>About</v-list-item-title>
                  </template>
                  <v-list-item
                    v-for="(item, index) in aboutItems"
                    :key="index"
                    :to="item.to"
                    link
                    @click="mobileMenu = false"
                  >
                    <v-list-item-title>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list-group>
                <v-list-item to="/store" @click="mobileMenu = false">
                  <v-list-item-title>Store</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isLoggedIn" to="/orders" @click="mobileMenu = false">
                  <v-list-item-title>My Orders</v-list-item-title>
                </v-list-item>
                <v-list-item @click="mobileMenu = false; openCart()">
                  <v-list-item-title>
                    Cart
                    <v-chip v-if="cartCount > 0" x-small color="#2E7D32" dark class="ml-2">{{ cartCount }}</v-chip>
                  </v-list-item-title>
                </v-list-item>
                <v-list-item to="/contact" @click="mobileMenu = false" class="mobile-contact">
                  <v-list-item-title>Contact Us</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!isLoggedIn" to="/login" @click="mobileMenu = false">
                  <v-list-item-title>Sign In</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!isLoggedIn" to="/register" @click="mobileMenu = false">
                  <v-list-item-title>Sign Up</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isLoggedIn" @click="mobileMenu = false; signOut()">
                  <v-list-item-title>Sign Out</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <!-- Cart drawer -->
    <cart-drawer></cart-drawer>

    <!-- Contenido principal -->
    <v-main class="main-content">
      <router-view></router-view>
    </v-main>

    <!-- Pie de página -->
    <v-footer color="black" dark padless class="footer">
      <v-container>
        <v-row justify="center" align="center">
          
          <v-col cols="3">
            <v-img
              src="@/assets/logo2.png"
              width="90%"
              max-width="330"
              contain
              class="mb-4"
              alt="LearnPlay Solutions Logo"
            ></v-img>
          </v-col>

          <v-col cols="3" md="8" lg="6" class="text-center">
            <div class="social-icons mb-4">
              <v-btn icon large to="/under" class="social-icon">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn
                icon
                large
                href="https://www.youtube.com/@LearnPlaySolutions"
                target="_blank"
                rel="noopener noreferrer"
                class="social-icon"
              >
                <v-icon>mdi-youtube</v-icon>
              </v-btn>
              <v-btn icon large to="/under" class="social-icon" target="/under">
                <v-icon>mdi-instagram</v-icon>
              </v-btn>
              <v-btn icon large to="/under" class="social-icon" target="/under">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
            </div>

            <p class="footer-text mb-2">© 2025 LearnPlay Solutions. All rights reserved.</p>

            <!-- <div class="footer-links">
              <v-btn text small to="/privacy" class="footer-link">Privacy Policy</v-btn>
              <v-btn text small to="/terms" class="footer-link">Terms of Service</v-btn>
              <v-btn text small to="/contact" class="footer-link">Contact</v-btn>
            </div> -->
          <p class="footer-text mb-2">Website designed with the support of AI tools.</p>
          </v-col>
          <v-col cols="3">
            <v-row>
              <v-btn text small to="/privacy" class="footer-link">Privacy Policy</v-btn></v-row>

              <v-row><v-btn text small to="/terms" class="footer-link">Terms of Service</v-btn></v-row>
              <v-row><v-btn text small to="/contact" class="footer-link">Contact</v-btn>
            </v-row>

          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import { auth } from '@/firebase';
import { cart } from '@/cart';
import CartDrawer from '@/components/CartDrawer.vue';

export default {
  name: 'App',
  components: { CartDrawer },

  async created() {
    // Procesa el resultado del Google redirect sign-in al volver a la app.
    // Funciona tanto en login como en registro.
    try {
      const result = await auth.getRedirectResult();
      if (result && result.user) {
        const token = await result.user.getIdToken();
        await fetch(process.env.VUE_APP_API_URL + '/profile.php', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
          body:    JSON.stringify({
            uid:           result.user.uid,
            email:         result.user.email,
            display_name:  result.user.displayName || '',
            photo_url:     result.user.photoURL    || '',
            auth_provider: 'google.com',
          }),
        });
        // El router guard (guestOnly) redirige automáticamente a /profile
      }
    } catch {
      // getRedirectResult devuelve null cuando no hay redirect pendiente – ignorar
    }

    auth.onAuthStateChanged(user => {
      this.currentUser = user;
    });
  },

  data() {
    return {
      mobileMenu: false,
      accountMenu: false,
      currentUser: null,
      aboutItems: [
        { title: 'Vision', to: '/vision' },
        { title: 'The Mission That Moves Us', to: '/mission' },
        { title: 'Our Team', to: '/ourteam' },
      ],
      approachItems: [
        { title: 'STEM Focused', to: '/stem' },
        { title: 'AI Agents', to: '/agents' },
        { title: 'Socratic Method', to: '/socratic' },
        { title: 'Development Strategies', to: '/strategies' },
        { title: 'Development Technologies', to: '/development' },
        { title: 'Pilot Program', to: '/pilot' },
      ],
    };
  },

  computed: {
    cartCount() { return cart.count; },
    isLoggedIn() {
      return !!this.currentUser;
    },
  },

  methods: {
    openCart() { cart.openDrawer(); },
    async signOut() {
      try {
        await auth.signOut();
        this.accountMenu = false;
        this.$router.push('/');
      } catch (error) {
        console.error('Sign out failed', error);
      }
    },
  },
};
</script>

<style scoped>
/* Estilos generales */
.main-content {
  min-height: calc(100vh - 90px - 200px);
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
}

/* Barra de navegación */
.main-navbar {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease;
}

.main-navbar.v-app-bar--is-scrolled {
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.15) !important;
  height: 70px !important;
}

.company-name {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 1.5rem;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.company-name:hover {
  color: #4CAF50;
}

/* Botones de navegación */
.nav-btn {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 1rem;
  text-transform: none;
  letter-spacing: 0.5px;
  color: #ffffff !important;
  margin: 0 8px;
  transition: all 0.3s ease;
}

.nav-btn:hover {
  color: #2E7D32 !important;
  transform: translateY(-2px);
}

.nav-btn::before {
  background-color: transparent !important;
}

.nav-btn.v-btn--icon {
  align-self: center;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  min-width: 40px !important;
  min-height: 40px !important;
  width: auto !important;
  height: auto !important;
  padding: 8px !important;
  margin: 0 8px !important;
}

.nav-btn.v-btn--icon .v-icon {
  font-size: 1.4rem !important;
}

/* Menú desplegable */
.nav-dropdown {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(46, 125, 50, 0.15) !important;
  border-top: 3px solid #4CAF50;
}

.dropdown-item {
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f0f9f0 !important;
}

.dropdown-item .v-list-item__title {
  color: #263238;
  font-weight: 500;
}

/* Botón de contacto */
.contact-btn {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 1rem;
  text-transform: none;
  letter-spacing: 0.5px;
  background-color: #2E7D32 !important;
  color: white !important;
  border-radius: 8px;
  padding: 0 24px;
  margin-left: 12px;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background-color: #1B5E20 !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(46, 125, 50, 0.3) !important;
}

/* Menú móvil */
.mobile-menu-btn {
  color: white !important; /* Asegura que el botón sea blanco */
}

.mobile-nav {
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.mobile-contact .v-list-item__title {
  color: #2E7D32;
  font-weight: 600;
}

/* Pie de página */
.footer {
  background: linear-gradient(135deg, #000000, #000000) !important;
  padding: 40px 0;
}

.footer-text {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.social-icon {
  color: white !important;
  transition: all 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-3px);
  color: #E0F7FA !important;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
}

.footer-link {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 0.85rem;
  color: white !important;
  text-transform: none;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.footer-link:hover {
  color: #E0F7FA !important;
  transform: translateY(-2px);
}

/* Efectos de hover globales */
.v-btn:before {
  background-color: transparent !important;
}

/* Responsive */
@media (max-width: 960px) {
  .company-name {
    font-size: 1.3rem;
  }
  
  .main-navbar.v-app-bar--is-scrolled {
    height: 60px !important;
  }
  
  .nav-btn {
    font-size: 0.9rem;
    margin: 0 6px;
  }
  
  .contact-btn {
    font-size: 0.9rem;
    padding: 0 16px;
    margin-left: 8px;
  }
}

@media (max-width: 600px) {
  .company-name {
    display: none;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 8px;
  }
  
  .footer-text {
    font-size: 0.8rem;
  }
  
  .social-icons .v-btn {
    width: 36px;
    height: 36px;
  }
  
  .main-content {
    min-height: calc(100vh - 70px - 180px);
  }
}
</style>